import { Navigate } from "react-router-dom";
import { useCurrentAdminPermissions } from "@/hooks/useCurrentAdminPermissions";
import NotFound from "@/pages/NotFound";

type AdminPermissionFlag =
  | "canViewBidsOverview"
  | "canViewDashboardOverview"
  | "canViewLeadboxListings"
  | "canManageSupport"
  | "canManageSettings";

interface AdminPermissionGateProps {
  children: React.ReactNode;
  permission: AdminPermissionFlag;
  /** When true, show 404 instead of redirecting to leadbox home. */
  notFound?: boolean;
}

/** Frontend gate for admin permission flags (pair with backend checkPermission). */
export function AdminPermissionGate({
  children,
  permission,
  notFound = true,
}: AdminPermissionGateProps) {
  const perms = useCurrentAdminPermissions();

  if (perms.isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[40vh]">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900" />
      </div>
    );
  }

  if (perms[permission] !== true) {
    if (notFound) return <NotFound />;
    return <Navigate to="/admin/leadbox" replace />;
  }

  return <>{children}</>;
}
